import { createSlice } from "@reduxjs/toolkit";
import { fetchRegionsBranches } from "thunks/trainingThunks/thunk";

const initialState = {
 
  availableBranches:[],
  updating: false,
};

const trainingSlicePrefetchData = createSlice({
  name: "trainingSlicePrefetchData",
  initialState,
  reducers: {
 
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchRegionsBranches.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchRegionsBranches.fulfilled, (state, action) => {
      state.loading = false;
      let branches = [];
      console.log("fetched",action.payload)
      action.payload?.forEach((elem) => {
        branches.push({
          id: elem.BRANCH_ID,
          label: elem.BRANCH_NAME,
        });
      });
      state.availableBranches = branches;
    })
    .addCase(fetchRegionsBranches.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
      
  },
});

export const {
  
} = trainingSlicePrefetchData.actions;

export default trainingSlicePrefetchData.reducer;
